"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleInstallPanelCms = void 0;
var ScheduleInstallPanelCms = /** @class */ (function () {
    function ScheduleInstallPanelCms() {
        this.panelTitleLabel = 'Installation';
        this.addInstallationCTALabel = 'Add installation info';
        this.editInstallAriaLabel = 'Edit installation info';
        this.updateInstallationCTALabel = 'Update installation info';
        this.contactInfoMissingErrorMessage = "Please select the \u201CEdit\u201D link below to provide us\n     your contact info for the day of installation.";
        this.schedulingLabel = "Scheduling";
        this.scheduleInstall = "Schedule your installation";
    }
    return ScheduleInstallPanelCms;
}());
exports.ScheduleInstallPanelCms = ScheduleInstallPanelCms;
//# sourceMappingURL=ScheduleInstallPanel.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/ScheduleInstallPanel/ScheduleInstallPanel.cms.js
// module id = 2021
// module chunks = 8